import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

export const customLightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: palettes.light,
  }),
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: ['#f9d84e', '#f9d84e'], shape: shapes.wave }),
    documentation: genPageTheme({ colors: ['#f9d84e', '#f9d84e'], shape: shapes.wave2 }),
    tool: genPageTheme({ colors: ['#f9d84e', '#f9d84e'], shape: shapes.round }),
    service: genPageTheme({ colors: ['#f9d84e', '#f9d84e'], shape: shapes.wave }),
    website: genPageTheme({ colors: ['#f9d84e', '#f9d84e'], shape: shapes.wave }),
    library: genPageTheme({ colors: ['#f9d84e', '#f9d84e'], shape: shapes.wave }),
    other: genPageTheme({ colors: ['#f9d84e', '#f9d84e'], shape: shapes.wave }),
    app: genPageTheme({ colors: ['#f9d84e', '#f9d84e'], shape: shapes.wave }),
    apis: genPageTheme({ colors: ['#f9d84e', '#f9d84e'], shape: shapes.wave }),
  },
  components: {
      BackstageHeader: {
        styleOverrides: {
          header: { color: '#000' },
          title: { color: '#000' },
          subtitle: { color: '#000' },
          leftItemsBox: { color: '#000' },
          rightItemsBox: { color: '#000' },
          type: { color: '#000' },
          breadcrumb: { color: '#000' },
          breadcrumbType: { color: '#000' },
          breadcrumbTitle: { color: '#000' },
        },
      },
      BackstageHeaderLabel: {
        styleOverrides: {
          root: { color: '#000' },
          label: { color: '#000' },
          value: { color: '#000' },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            color: '#000',
          },
        },
      },
  },
});


export const customDarkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: palettes.dark,
  }),
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: ['#f9d84e', '#f9d84e'], shape: shapes.wave }),
    documentation: genPageTheme({ colors: ['#f9d84e', '#f9d84e'], shape: shapes.wave2 }),
    tool: genPageTheme({ colors: ['#f9d84e', '#f9d84e'], shape: shapes.round }),
    service: genPageTheme({ colors: ['#f9d84e', '#f9d84e'], shape: shapes.wave }),
    website: genPageTheme({ colors: ['#f9d84e', '#f9d84e'], shape: shapes.wave }),
    library: genPageTheme({ colors: ['#f9d84e', '#f9d84e'], shape: shapes.wave }),
    other: genPageTheme({ colors: ['#f9d84e', '#f9d84e'], shape: shapes.wave }),
    app: genPageTheme({ colors: ['#f9d84e', '#f9d84e'], shape: shapes.wave }),
    apis: genPageTheme({ colors: ['#f9d84e', '#f9d84e'], shape: shapes.wave }),
  },
  components: {
    BackstageHeader: {
        styleOverrides: {
          header: { color: '#000' },
          title: { color: '#000' },
          subtitle: { color: '#000' },
          leftItemsBox: { color: '#000' },
          rightItemsBox: { color: '#000' },
          type: { color: '#000' },
          breadcrumb: { color: '#000' },
          breadcrumbType: { color: '#000' },
          breadcrumbTitle: { color: '#000' },
        },
      },
      BackstageHeaderLabel: {
        styleOverrides: {
          root: { color: '#000' },
          label: { color: '#000' },
          value: { color: '#000' },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            color: '#000',
          },
        },
      },      
  },
});